import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import type { CentreOption } from '../types';

interface UseCentresReturn {
  centres: CentreOption[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

// Plan 4K Phase 2: fetches the active CRM centres so CreateEventPage
// can offer a Centre dropdown. App Backend GET /centres proxies CRM
// /api/v1/centres and reshapes to the camelCase {id, name, region} form.
export function useCentres(): UseCentresReturn {
  const [centres, setCentres] = useState<CentreOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCentres = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get<CentreOption[]>('/centres');
      setCentres(res.data);
      setError(null);
    } catch (err) {
      setError('Failed to load centres');
      console.error('Failed to fetch centres:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCentres();
  }, [fetchCentres]);

  return { centres, loading, error, refetch: fetchCentres };
}
